import { useState } from 'react'

// styles 
import '../project/Project.css'

const filters = ['working', 'archived', 'all']

export default function ProjectFilter({setVisibleProjects, projectDocs}) {
  const [currFilter, setCurrFilter] = useState('working')

  const handleClick = (newFilter) => {
    setCurrFilter(newFilter)
    let vis = []
    switch (newFilter) {
      case 'working':
        projectDocs.forEach(p => {
          if (p.archived === false) {
            vis.push(p)
          }
        })
        break
      case 'all':
        vis = projectDocs
        break
      case 'archived':
        projectDocs.forEach(p => {
          if (p.archived === true) {
            vis.push(p)
          }
        })
        break
      default:
        break
    }
    setVisibleProjects(vis)
  }

  return (
    <div className='filter'>
      <nav>
        {filters.map(f => (
          <button 
            key={f}
            className={currFilter === f ? 'active' : ''}
            onClick={() => handleClick(f)}
          >
            {f}
          </button>
        ))}
      </nav>
    </div>
  )
}
